import React from "react";

interface Props {
	className?: string;
	size?: number;
}

export const IconCheckBlueLg: React.FC<Props> = ({
	className = "",
	size = 28,
}) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M9.75 14.9911L12.9375 18.1786L18.25 10.7411M26.75 13.9286C26.75 15.6029 26.4202 17.2609 25.7795 18.8078C25.1387 20.3547 24.1996 21.7602 23.0156 22.9442C21.8317 24.1281 20.4261 25.0673 18.8792 25.708C17.3323 26.3488 15.6744 26.6786 14 26.6786C12.3256 26.6786 10.6677 26.3488 9.12079 25.708C7.57388 25.0673 6.16834 24.1281 4.98439 22.9442C3.80044 21.7602 2.86128 20.3547 2.22054 18.8078C1.57979 17.2609 1.25 15.6029 1.25 13.9286C1.25 10.5471 2.5933 7.30405 4.98439 4.91296C7.37548 2.52187 10.6185 1.17857 14 1.17857C17.3815 1.17857 20.6245 2.52187 23.0156 4.91296C25.4067 7.30405 26.75 10.5471 26.75 13.9286Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
